//#region Libraries
import { 
    NameCell as NameCellD, 
    TDefContent, 
    TeacherNameCell as TeacherNameCellD 
} from "components/CustomTableList/components/TableListItem/ListItem/styles";
import styled from "styled-components";
//#endregion

export const Container = styled.tr`
    margin: 5px 0;
    width: 100%;
    line-height: 30px;
    &.is-past > td > div:not(.actions-cell) * {
        color: var(--purple-4) !important;
        pointer-events: none;
        svg path {
            fill: var(--purple-4) !important;
        }
    }
`;
export const NameCell = styled(NameCellD)`
    min-width: 270px;
    & h3 {
        margin: 0;
        font-size: 16px;
        width: 290px;
    }
`;
export const StateCell = styled(TDefContent)`
`;
export const TeacherNameCell = styled(TeacherNameCellD)`
    & h5 {
        max-width: 130px;
    }
`;
